import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵadvance, ɵɵtextInterpolate1, ɵɵdefineComponent, ɵɵelement, ɵɵtemplate, ɵɵproperty, Component, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { NgForOf, CommonModule } from '@angular/common';

class NgxDatetimePickerService {
    constructor() {
    }
}
NgxDatetimePickerService.ɵfac = function NgxDatetimePickerService_Factory(t) { return new (t || NgxDatetimePickerService)(); };
NgxDatetimePickerService.ɵprov = ɵɵdefineInjectable({ token: NgxDatetimePickerService, factory: NgxDatetimePickerService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NgxDatetimePickerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function NgxDatetimePickerComponent_th_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "th");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const day_r1 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", day_r1, " ");
} }
class NgxDatetimePickerComponent {
    constructor() {
        this.firstDay = 0;
        this.weekdaysShort = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ];
    }
    ngOnInit() {
    }
}
NgxDatetimePickerComponent.ɵfac = function NgxDatetimePickerComponent_Factory(t) { return new (t || NgxDatetimePickerComponent)(); };
NgxDatetimePickerComponent.ɵcmp = ɵɵdefineComponent({ type: NgxDatetimePickerComponent, selectors: [["datetime-picker"]], decls: 12, vars: 1, consts: [[1, "datetime-picker-single"], [1, "datetime-picker-lender"], [1, "datetime-picker-title"], ["type", "button", 1, "datetime-picker-prev"], ["type", "button", 1, "datetime-picker-next"], ["cellpadding", "0", "cellspacing", "0", "role", "grid", "aria-labelledby", "datetime-picker", 1, "datetime-picker-table"], [4, "ngFor", "ngForOf"]], template: function NgxDatetimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵtext(3, " February ");
        ɵɵelement(4, "button", 3);
        ɵɵelement(5, "button", 4);
        ɵɵelementEnd();
        ɵɵelementStart(6, "table", 5);
        ɵɵelementStart(7, "thead");
        ɵɵelementStart(8, "tr");
        ɵɵtemplate(9, NgxDatetimePickerComponent_th_9_Template, 2, 1, "th", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "p");
        ɵɵtext(11, " ngx-datetime-picker works!!\n");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(9);
        ɵɵproperty("ngForOf", ctx.weekdaysShort);
    } }, directives: [NgForOf], styles: ["@charset \"UTF-8\";.datetime-picker-single[_ngcontent-%COMP%]{z-index:9999;display:block;position:relative;color:#333;background:#fff;border:1px solid #ccc;border-bottom-color:#bbb;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;width:240px}.datetime-picker-single[_ngcontent-%COMP%]:before, .datetime-picker[_ngcontent-%COMP%]:after{content:\" \";display:table}.datetime-picker[_ngcontent-%COMP%]:after{clear:both}.datetime-picker-lender[_ngcontent-%COMP%]{margin:8px}.datetime-picker-title[_ngcontent-%COMP%]{position:relative;text-align:center}.datetime-picker-next[_ngcontent-%COMP%], .datetime-picker-prev[_ngcontent-%COMP%]{display:block;cursor:pointer;position:relative;outline:0;border:0;padding:0;width:20px;height:30px;text-indent:20px;white-space:nowrap;overflow:hidden;background-color:transparent;background-position:center center;background-repeat:no-repeat;background-size:75% 75%;opacity:.5}.datetime-picker-prev[_ngcontent-%COMP%]{float:left;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==)}.datetime-picker-next[_ngcontent-%COMP%]{float:right;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=)}.datetime-picker-table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse;border-spacing:0;border:0}.datetime-picker-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .datetime-picker-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{width:14.285714285714286%;padding:0}.datetime-picker-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#999;font-size:12px;line-height:25px;font-weight:700;text-align:center}p[_ngcontent-%COMP%]{color:red}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NgxDatetimePickerComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line component-selector
                selector: 'datetime-picker',
                templateUrl: './ngx-datetime-picker.component.html',
                styleUrls: ['./ngx-datetime-picker.component.css']
            }]
    }], function () { return []; }, null); })();

class NgxDatetimePickerModule {
}
NgxDatetimePickerModule.ɵmod = ɵɵdefineNgModule({ type: NgxDatetimePickerModule });
NgxDatetimePickerModule.ɵinj = ɵɵdefineInjector({ factory: function NgxDatetimePickerModule_Factory(t) { return new (t || NgxDatetimePickerModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(NgxDatetimePickerModule, { declarations: [NgxDatetimePickerComponent], imports: [CommonModule], exports: [NgxDatetimePickerComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(NgxDatetimePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxDatetimePickerComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgxDatetimePickerComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-datetime-picker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxDatetimePickerComponent, NgxDatetimePickerModule, NgxDatetimePickerService };
//# sourceMappingURL=ngx-datetime-picker.js.map
